<div class="login-page-container">
    <div class="login-container" id=login-container>

        <!-- svg logo -->
        <div class="logo">
            <mat-icon class="logo-icon" [svgIcon]="'license_manager_login'"></mat-icon>
        </div>


        <!-- motto (subtitle) section -->
        <div class="motto is-h6">
            {{ 'create_user_title' | translate }}
        </div>

        <form class="login-form-container" [formGroup]="createUserForm" autocomplete="off">
            <div class="flex mb--10">
                <mat-form-field appearance="outline" class="mr--10" autocomplete="off">
                    <input matInput type="text" class="is-h6" placeholder='{{"first_name" | translate}}*'
                        formControlName="first_name" autocomplete="new-name">
                </mat-form-field>
                <mat-form-field appearance="outline" class="ml--10" autocomplete="off">
                    <input matInput type="text" class="is-h6" placeholder='{{"last_name" | translate}}*'
                        formControlName="last_name" autocomplete="new-surname">
                </mat-form-field>
            </div>
            <mat-form-field class="mb--10" appearance="outline" autocomplete="off">
                <input matInput type="text" class="is-h6" placeholder='{{"username" | translate}}*'
                    formControlName="username" autocomplete="new-username">
            </mat-form-field>
            <mat-form-field class="mb--10"appearance="outline" floatLabel="never" (click)="subscribeCompany(); customerList = []">
                <mat-select placeholder="{{'customer' | translate}}*" color="primary" formControlName="company"
                    (closed)="selectCustomers()" [required]="true">
                    <mat-option>
                        <ngx-mat-select-search [placeholderLabel]="'site_filter' | translate" [formControl]="customerNgx"
                            [noEntriesFoundLabel]="'no_elements' | translate">
                            <mat-icon ngxMatSelectSearchClear svgIcon="close"></mat-icon>
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null">
                        {{ 'none' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let customer of customerList" [value]="customer.id">
                        {{customer.code}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="mb--10" autocomplete="off">
                <input matInput type="email" class="is-h6" placeholder='{{"email" | translate}}*' formControlName="email"
                    autocomplete="new-email">
                <mat-error *ngIf="createUserForm.get('email')?.hasError('email')">
                    Email non valida
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="mb--10" autocomplete="off">
                <input matInput type="password" class="is-h6" placeholder='{{"password" | translate}}*' formControlName="password"
                    autocomplete="new-password">
            </mat-form-field>
            <mat-form-field appearance="outline" class="mb--10" autocomplete="off">
                <input matInput type='password' class="is-h6" placeholder='{{"confirm_password" | translate}}*' formControlName="confirm_password"
                    autocomplete="new-password">
            </mat-form-field>
            <button mat-flat-button type="submit" color="primary" class="clickable is-button"
                [disabled]="!createUserForm?.valid" (click)="createUser()">
                <span>{{"register" | translate | uppercase}}</span>
            </button>
            <div class="subtitle clickable mt--20 align-center flex center">
                <span class="mr--5">{{"back_to_login" | translate}}</span>
                <span style="font-weight: 500; cursor: pointer;" (click)="goToLogin()">{{"go_to_login" | translate
                    }}</span>
            </div>
        </form>
    </div>
</div>